import { defineComponent as _defineComponent } from 'vue'
import Overlay from '@components/Overlay.vue';
import Spinner from '@components/Spinner.vue';

/**
 * `OverlayLoading` component properties.
 */
export interface Props {
  /**
   * Message to display with the overlay.
   */
  message?: string;
  /**
   * Color to use for the overlay's spinner.
   */
  color?: string;
  /**
   * Blur to use for the overlay's background.
   */
  blur?: string;
  /**
   * Color to use for the overlay's background
   */
  background?: 'none' | (string & {});
  /**
   * Whether the overlay should be fullscreen, or constrained to the parent
   * element.
   */
  fullscreen?: boolean;
  /**
   * Transition of the overlay.
   */
  transition?: string | number;
}


declare module 'vue/types/vue' {
  export interface Vue {
    OverlayLoading: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'OverlayLoading' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: null,
    color: null,
    blur: null,
    background: null,
    fullscreen: { type: Boolean },
    transition: null
  },
  setup(__props: any) {



return { __sfc: true,Overlay, Spinner }
}

})